import ErrorBoundary from "../../components/errorBoundary/ErrorBoundary";
import PropTypes from "prop-types";
import RecommendedOutfits from "../../components/recommendedOutfits/RecommendedOutfits";
import YouMightAlsoLike from "../../components/youMightAlsoLike/YouMightAlsoLike";
import RatingsAndReviewsApp from "../../RatingsAndReviewsApp";
import RecentlyViewed from "../../components/recentlyViewed/RecentlyViewed";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useIsInStockContext } from "../../context/isInStock/IsInStockContext";
import useRatingsFeatureRequirements from "../../hooks/ratingsFeatureRequirements/useRatingsFeatureRequirements";
import getSdks from "../../utils/sdks";
import getWindow from "../../utils/window";
import ReturnNotesSummary from "../../components/returnNotesSummary/ReturnNotesSummary";
import PeopleAlsoBought from "../../components/peopleAlsoBought/PeopleAlsoBought";
import LooksSection from "../../components/looks/LooksSection";
import { useLooksProducts } from "../../context/looks/LooksProductsContext";
import useDiscountPercentage from "../../hooks/useDiscountPercentage";
import useRecommendationProducts from "./useRecommendationProducts";
import { useRecommendedOutfits } from "../../context/recommendedOutfits/RecommendedOutfitsContext";
import WaysToStyle from "../../components/waysToStyle/WaysToStyle";
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";

export default function CarouselsAndReviews({ product }) {
  const { isStockStateReady, isInStock } = useIsInStockContext();
  const { isMixAndMatch, ratings, isMobile } = useRuntimeConstants();
  const { showDiscountPercentage } = useDiscountPercentage();
  const ratingsFeatureRequirementsAchieved = useRatingsFeatureRequirements(
    ratings,
    isInStock,
  );
  function isScreenHoverable() {
    return getWindow().matchMedia("(hover: hover)").matches;
  }
  const screenHoverable = isScreenHoverable();
  const { showUpSell } = product;
  const { shouldShowLooksSection } = useLooksProducts();
  const { recommendations: recommendationProducts, recsRequestId } =
    useRecommendationProducts({
      showUpSell,
      isInStock,
      isStockStateReady,
      isMixAndMatch,
    });
  const { shouldShowRecommendedOutfits } = useRecommendedOutfits();
  const { shouldShowWaysToStyle } = useWaysToStyle();

  const renderPeopleAlsoBought = () =>
    recommendationProducts.length > 0 && (
      <PeopleAlsoBought
        sdks={getSdks()}
        products={recommendationProducts}
        recsRequestId={recsRequestId}
        showDiscountPercentage={showDiscountPercentage}
      />
    );

  const renderRatingsAndReviewsApp = () =>
    !isMixAndMatch &&
    ratingsFeatureRequirementsAchieved &&
    ratings?.displayRatingsSection && (
      <ErrorBoundary>
        <RatingsAndReviewsApp screenHoverable={screenHoverable} />
      </ErrorBoundary>
    );

  const renderReturnNotesSummary = () =>
    !isMixAndMatch && <ReturnNotesSummary />;

  const renderMightLike = () =>
    showUpSell && isStockStateReady && <YouMightAlsoLike />;

  const renderWaysToStyle = () => shouldShowWaysToStyle && <WaysToStyle />;

  const renderLooksSection = () =>
    (!isMobile || !shouldShowWaysToStyle) &&
    showUpSell &&
    shouldShowLooksSection && <LooksSection product={product} />;

  const renderRecentlyViewed = () =>
    showUpSell && <RecentlyViewed screenHoverable={screenHoverable} />;

  const renderRecommendedOutfits = () => <RecommendedOutfits />;

  return (
    <div>
      {renderMightLike()}
      {renderWaysToStyle()}
      {renderLooksSection()}
      {renderPeopleAlsoBought()}
      {shouldShowRecommendedOutfits && renderRecommendedOutfits()}
      {renderReturnNotesSummary()}
      {renderRatingsAndReviewsApp()}
      {renderRecentlyViewed()}
    </div>
  );
}

CarouselsAndReviews.propTypes = {
  product: PropTypes.object.isRequired,
};
